import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { SiteHeader } from './components/SiteHeader';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-brand-main font-sans text-brand-text selection:bg-brand-amber/25" data-id="element-0" data-mp="23vci6nubd29i">
      <MetaPixel data-id="element-1" data-mp="3ik7k0rkruvvx" />
      <SiteHeader data-id="element-2" data-mp="3ikqwvtvkeu33" />
      <main data-id="element-3" data-mp="3ij61k21ff746">
        <HeroSection data-id="element-4" data-mp="3ijpd910hgz9r" />
        <StatsBar data-id="element-5" data-mp="3ii4q3wgi0ilx" />
        <TransformationSection data-id="element-6" data-mp="3mlatmwc87vop" />
        <PainPointsSection data-id="element-7" data-mp="3mk868ye44bdj" />
        <KitContentsSection data-id="element-8" data-mp="3mjga9mglsbmq" />
        <InstantAccessSection data-id="element-9" data-mp="3rcj7q5oi4587" />
        <BonusesSection data-id="element-10" data-mp="3rdarmj8qkein" />
        <PricingSection data-id="element-11" data-mp="3rd19tixuhdo1" />
        <GuaranteeSection data-id="element-12" data-mp="5yjsutqtdfe" />
        <FAQSection data-id="element-13" data-mp="67z9oh5w26u" />
        <FinalCTASection data-id="element-14" data-mp="4n5i12o8na1" />
      </main>
      <Footer data-id="element-15" data-mp="7svdij4jt6t" />
    </div>;
}